import type { InstrumentId } from "./score";

/** Original vector silhouettes: no emoji/font or external asset dependency. */
export const InstrumentIcon: React.FC<{ instrument: InstrumentId }> = ({
  instrument,
}) => (
  <g
    fill="none"
    stroke="currentColor"
    strokeWidth="3.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {instrument === "marimba" && (
      <>
        {[-21, -7, 7, 21].map((x, i) => (
          <rect
            key={x}
            x={x - 5}
            y={-12 + i * 2}
            width="10"
            height={34 - i * 4}
            rx="2"
            fill="currentColor"
            fillOpacity=".2"
          />
        ))}
        <path d="M-24 -25 L-5 -12 M24 -25 L5 -12 M-21 25 H21" />
        <circle cx="-25" cy="-26" r="4" fill="currentColor" />
        <circle cx="25" cy="-26" r="4" fill="currentColor" />
      </>
    )}
    {instrument === "bell" && (
      <>
        <path
          d="M-23 15 Q-16 8 -16 -7 C-16 -28 16 -28 16 -7 Q16 8 23 15 Z"
          fill="currentColor"
          fillOpacity=".18"
        />
        <path d="M-7 22 Q0 31 7 22 M0 -28 V-32" />
      </>
    )}
    {instrument === "bass" && (
      <g transform="rotate(28)">
        <path
          d="M-7 -8 C-28 -14 -26 4 -19 9 C-32 30 -5 37 9 22 C18 12 12 3 7 0 C16 -12 3 -20 0 -8"
          fill="currentColor"
          fillOpacity=".18"
        />
        <path d="M-3 15 V-32 H4 V15 M-10 18 H8 M-4 -33 L-4 -39 H6 V-33 M-8 -35 H-4 M6 -38 H10" />
      </g>
    )}
    {instrument === "percussion" && (
      <>
        <ellipse cy="-4" rx="24" ry="9" fill="currentColor" fillOpacity=".18" />
        <path d="M-24 -4 V19 C-24 31 24 31 24 19 V-4 M-23 2 L-12 23 L0 5 L12 23 L23 2 M-23 -28 L6 -10 M23 -28 L-6 -10" />
      </>
    )}
  </g>
);
